import React, { useEffect, useState, Suspense } from 'react';
import Constants from 'expo-constants';
import { useFonts } from 'expo-font';
import { RacingSansOne_400Regular } from '@expo-google-fonts/racing-sans-one';
import ComingSoonScreen from './components/ComingSoonScreen';
import { db } from './firebase';
import { doc, onSnapshot } from 'firebase/firestore';
const FullApp = React.lazy(() => import('./components/FullApp'));
const LazyAdmin = React.lazy(() => import('./components/AdminScreen'));

export default function App() {
	const [fontsLoaded] = useFonts({ RacingSansOne_400Regular });
	const [comingSoonOnly, setComingSoonOnly] = useState(true); // default safe
	const [cfgReady, setCfgReady] = useState(false);

	// Default to production behavior (fetch from Firestore) unless running on localhost
	const isLocalDev = typeof window !== 'undefined' && 
		(window.location.hostname === 'localhost' || 
		 window.location.hostname === '127.0.0.1' ||
		 window.location.hostname.includes('192.168'));

	useEffect(() => {
		// Skip Firestore check ONLY if running on localhost (local development)
		// All deployed sites (any real domain) will fetch the config
		if (isLocalDev) {
			// Local dev only - skip config check and show full app
			setComingSoonOnly(false);
			setCfgReady(true);
			return;
		}
		
		const ref = doc(db, 'config', 'site');
		const unsub = onSnapshot(ref, (snap) => {
			const data = snap.data() || {};
			setComingSoonOnly(Boolean(data.comingSoon));
			setCfgReady(true);
		}, (error) => {
			console.error('Error fetching config:', error);
			setCfgReady(true);
		});
		return () => unsub();
	}, [isLocalDev]);

	if (!fontsLoaded || !cfgReady) return null;

	// Respect Coming Soon flag from Firestore (applies to all deployed sites)
	if (comingSoonOnly) {
		// Coming soon mode: render Admin only on /admin, otherwise ComingSoon.
		const path = typeof window !== 'undefined' ? String(window.location.pathname || '').toLowerCase() : '';
		if (path.includes('/admin')) {
			return (
				<Suspense fallback={null}>
					<LazyAdmin />
				</Suspense>
			);
		}
		return <ComingSoonScreen />;
	}

	// Full site mode in production
	return (
		<Suspense fallback={null}>
			<FullApp />
		</Suspense>
	);
}
